import produce from "immer";

import { contextConstants } from "context/constants";
import { set } from "lodash";

const LOADING_CANDIDATES_TEXT = "Loading...";

export const initialState = {
  matches: [],
  ideal: [],
  loadingIdeal: LOADING_CANDIDATES_TEXT,
  mappedHitsTabMatchesForDownload: null,
  isReRankingMatches: false,
};

export const reducer = produce((draft, action) => {
  const { type, payload } = action;

  switch (type) {
    case contextConstants.match.MAPPED_HITS_TAB_MATCHES_FOR_DOWNLOAD_UPDATED: {
      draft.mappedHitsTabMatchesForDownload =
        payload.mappedHitsTabMatchesForDownload;
      break;
    }

    case contextConstants.match.MATCHES_LOADED: {
      draft.matches = payload.matches;
      break;
    }

    case contextConstants.match.MATCH_1_LEVEL_FIELD_UPDATED: {
      const index = draft.matches.findIndex(
        (match) => match.applicationId === payload.applicationId
      );
      if (index !== -1) {
        draft.matches[index][payload.fieldKey] = payload.value;
      }
      break;
    }

    case contextConstants.match.IDEAL_CANDIDATE_FIELD_UPDATED: {
      const index = draft.ideal.findIndex((fit) => fit.id === payload.userId);
      if (index !== -1) {
        set(draft.ideal[index], payload.fieldKey, payload.value);
      }
      break;
    }

    case contextConstants.match.MATCH_USER_FIELD_UPDATED: {
      const index = draft.matches.findIndex(
        (match) => match.applicationId === payload.applicationId
      );
      if (index !== -1 && draft.matches[index]?.user) {
        draft.matches[index].user[payload.fieldKey] = payload.value;
      }
      break;
    }

    case contextConstants.match.IDEAL_CANDIDATES_LOADED: {
      draft.ideal = payload.ideal;

      if (Object.keys(payload).includes("loadingIdeal")) {
        draft.loadingIdeal = payload.loadingIdeal;
      }
      break;
    }

    case contextConstants.match.LOADING_IDEAL_CANDIDATES: {
      draft.loadingIdeal = LOADING_CANDIDATES_TEXT;
      break;
    }

    case contextConstants.match.IS_RE_RANKING_MATCHES_CHANGED: {
      draft.isReRankingMatches = payload.isReRankingMatches;
      break;
    }

    default: {
      break;
    }
  }
});
